export default __webpack_public_path__ + "static/media/misc-pantry3-768w.4a22e7af.png";